import { TranslatedString } from "@gnu-taler/taler-util";
import { Fragment, h, VNode } from "preact";
import { useEffect, useState } from "preact/hooks";
import { useTranslationContext } from "../../context/translation.js";
import { resolveFieldHandler, UIFormProps } from "../FormProvider.js";
import { InputSelectOne } from "./InputSelectOne.js";

export function InputDrilldown(
  props: {
    choices?: any;
  } & UIFormProps<any>,
): VNode {
  const { hidden, choices, required } = props;
  const { onChange } = resolveFieldHandler(props.handler, props.name);
  const [choiceStack, setChoiceStack] = useState<string[]>([]);
  const { i18n: localI18n } = useTranslationContext();
  useEffect(() => setChoiceStack([]), [choices]);

  if (hidden || !choices || typeof choices !== "object") {
    return <Fragment />;
  }

  let ch = props.choices;

  let inputs = [];

  for (let lvl = 0; lvl < choiceStack.length + 1; lvl++) {
    if (typeof ch === "string") {
      break;
    }
    inputs.push(
      <InputSelectOne
        name={props.name}
        label={localI18n.str`${props.label} (Classification level ${lvl + 1})`}
        required={required}
        disabled={props.disabled}
        handler={{
          field: {
            name: choiceStack.join(","),
            onChange(x) {
              if (x != null) {
                const cs = [...choiceStack.slice(0, lvl), x];
                let myCh = props.choices;
                for (let c of cs) {
                  myCh = myCh[c];
                }
                if (typeof myCh === "string") {
                  onChange(myCh);
                }
                setChoiceStack(cs);
              } else {
                setChoiceStack([...choiceStack.slice(0, lvl)]);
                onChange(undefined);
              }
            },
            value: choiceStack[lvl],
          },
        }}
        choices={Object.keys(ch).map((x) => ({
          label: x as TranslatedString,
          value: x,
        }))}
      />,
    );

    ch = ch[choiceStack[lvl]];
  }

  return <>{inputs}</>;
}
